import { useDisconnect } from '@reown/appkit/react'
import { useNavigate } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'

export function useLogout() {
	const { disconnect } = useDisconnect()
	const navigate = useNavigate()
	const clearAuth = useAuthStore((state) => state.auth.clearAuth)

	const clearAllData = () => {
		// Clear localStorage
		localStorage.clear()

		// Clear sessionStorage
		sessionStorage.clear()

		// Clear all cookies
		document.cookie.split(';').forEach((c) => {
			const eqPos = c.indexOf('=')
			const name = eqPos > -1 ? c.substr(0, eqPos) : c
			document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
			document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`
			document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`
		})

		// Clear auth store
		clearAuth()
	}

	const handleLogout = async () => {
		try {
			// Disconnect wallet
			await disconnect()

			// Clear all data
			clearAllData()

			// Navigate to home
			navigate({
				to: '/',
			})
		} catch (error) {
			// Even if disconnect fails, still clear data
			clearAllData()

			alert(
				'Error logging out: ' +
					(error instanceof Error ? error.message : 'Unknown error'),
			)
		}
	}

	return {
		handleLogout,
		clearAllData,
	}
}
